import LanguageSkillTag from './LanguageSkillTag';

export default LanguageSkillTag;
